export default __webpack_public_path__ + "static/media/10.e5c5bd25.mp3";